/* eslint-disable react/jsx-no-constructed-context-values */
/* eslint-disable react/jsx-props-no-spreading */
import React, {
  createContext, useContext, useState,
} from 'react';
import { CoreDialogContextProps } from './CoreDialogContext.types';
import { CoreDialogProviderProps } from './CoreDialogProviderProps.types';

const CoreDialogContext = createContext<CoreDialogContextProps>(undefined!);
export function useCoreDialog() {
  return useContext(CoreDialogContext);
}

export function CoreDialogProvider({ children }: CoreDialogProviderProps) {
  const [dialogOpen, setDialogOpen] = useState(false);
  const [submitDisabled, setSubmitDisabled] = useState(true);

  return (
    <CoreDialogContext.Provider
      value={{
        dialogOpen,
        submitDisabled,
        setSubmitDisabled,
        setDialogOpen,
      }}
    >
      {children}
    </CoreDialogContext.Provider>
  );
}
